// extracted by mini-css-extract-plugin
export var attribution = "_cz-4";
export var authorName = "_cz-5";
export var quote = "_cz-3";
export var testimonial = "_cz-2";
export var trustedBy = "_cz-0";
export var trustedByLabel = "_cz-1";